export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50">虫虫动漫</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              虫虫动漫按韩漫、日漫、国漫分类提供漫画资源，免费在线看热门韩国日本国产漫画，下拉式阅读体验，分类清晰选漫无忧。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门榜单', href: '#ranking' },
                { label: '关于我们', href: '#about' },
                { label: '特色优势', href: '#features' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">漫画分类</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-400">韩国漫画</span></li>
              <li><span className="text-sm text-background-400">日本漫画</span></li>
              <li><span className="text-sm text-background-400">国产漫画</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-500">优质漫画内容平台</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 虫虫动漫 - 韩漫日漫国漫免费在线阅读平台
          </p>
          <p className="text-xs text-background-500">
            下拉式阅读 · 分类清晰 · 每日更新
          </p>
        </div>
      </div>
    </footer>
  );
}